import * as process from 'process';
import { Buffer } from 'buffer';
import { Aurelia } from 'aurelia-framework';
import { HTMLSanitizer } from 'aurelia-templating-resources';
import { HtmlSanitizer } from 'framework/html-sanitizer';
import { Repeat } from 'aurelia-templating-resources';
import { Auth } from 'framework/auth_support/af-auth';
import { MobileAppService } from './services/mobile-app-service';
import { configure as configureDialog } from 'aurelia-dialog';
import { configure as configureValidation, GlobalValidationConfiguration, validateTrigger } from 'aurelia-validation';
import { configure as configureDeepComputed } from 'aurelia-deep-computed';
import { configure as configureVirtualization } from 'aurelia-ui-virtualization';
import { configure as configureReorderableRepeat } from 'bcx-aurelia-reorderable-repeat';
import { configure as configureClientApi } from 'api/client/support/setup';
import 'bootstrap';
import environment from './environment';

(window as any).process = process;
(window as any).Buffer = Buffer;

export function configure(aurelia: Aurelia) {
  Repeat.useInnerMatcher = false;

  aurelia.use
    .standardConfiguration()
    .plugin(configureDialog)
    .plugin(configureValidation, (config: GlobalValidationConfiguration) => config.defaultValidationTrigger(validateTrigger.changeOrBlur))
    .plugin(configureDeepComputed)
    .plugin(configureVirtualization)
    .plugin(configureReorderableRepeat)
    .singleton(HTMLSanitizer, HtmlSanitizer)
    .developmentLogging(environment.debug ? 'debug' : 'warn');

  if (environment.testing)
    aurelia.use.plugin('aurelia-testing');

  if (environment.apiUrl != null)
    configureClientApi(aurelia.container);

  const stop = error => {
    console.error(error);
    alert('Sorry, the application is unavailable at the moment. Please try to reload this page after a while. If the problem problem persists, contact support.');
  };

  const isMobileApp = () => {
    const mobileAppService = aurelia.container.get(MobileAppService) as MobileAppService;
    mobileAppService.init();
  }

  const authenticate = () => {
    const auth = aurelia.container.get(Auth) as Auth;
    return auth
      .initialize()
      .then(() => auth.handleRedirectReponse())
      .then(() => auth.ensureIsAuthenticated())
      .catch(error => stop(error));
  };

  let boot: Promise<unknown> = aurelia.start();

  if (environment.authSettings)
    boot = boot
      .then(() => authenticate())
      .then(() => isMobileApp());

  boot.then(() => aurelia.setRoot());
}
